import React from 'react'

const SelectInputWrapper = React.forwardRef((props, ref) => (
  <div className='form-group'>
    <div className='col-sm-12'>
      <label className='region-label'>
        {props.label}
        <select className='form-control' name={props.name} ref={ref} onChange={props.onChange}>
          { props.options.map((o, i) => {
            const value = Array.isArray(o) ? o[1] : o
            const label = Array.isArray(o) ? o[0] : o
            return <option key={i} value={value}>{label}</option>
          })}
        </select>
      </label>
    </div>
  </div>
))

export default SelectInputWrapper
